import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import React from "react";
import PagesPanel from "./PagesPanel";
import Layers from "./Layers";

const PAGES_DEFAULT_PERCENT = 20;
const PAGES_MIN_HEIGHT = 40; // px
const PAGES_MAX_PERCENT = 70;
const LAYERS_MIN_HEIGHT = 120; // px

const PagesPane = React.memo(() => {
  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <ResizablePanelGroup direction="vertical" className="flex-1 min-h-0">
        <ResizablePanel
          defaultSize={PAGES_DEFAULT_PERCENT}
          minSize={0}
          maxSize={PAGES_MAX_PERCENT}
          style={{ minHeight: PAGES_MIN_HEIGHT }}
        >
          <PagesPanel />
        </ResizablePanel>

        <ResizableHandle withHandle showOnHover />

        <ResizablePanel
          defaultSize={100 - PAGES_DEFAULT_PERCENT}
          minSize={0}
          style={{ minHeight: LAYERS_MIN_HEIGHT }}
        >
          <Layers />
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  );
});

PagesPane.displayName = "PagesPane";

export default PagesPane;
